
riot.tag2('sms-template-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#settings/sms"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.name || \'Новый SMS шаблон\' : item.name || \'Редактирование SMS шаблона\'}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-6">\n          <div class="form-group {has-error: error.name}">\n            <label class="control-label">Заголовок</label>\n            <input class="form-control" name="name" value="{item.name}">\n            <div class="help-block">{error.name}</div>\n          </div>\n        </div>\n        <div class="col-md-6">\n          <div class="form-group {has-error: error.code}">\n            <label class="control-label">Код</label>\n            <input class="form-control" name="code" value="{item.code}">\n            <div class="help-block">{error.code}</div>\n          </div>\n        </div>\n        <div class="col-md-6">\n          <div class="form-group {has-error: error.phone}">\n            <label class="control-label">Телефон</label>\n            <input class="form-control" name="phone" value="{item.phone}">\n            <div class="help-block">{error.phone}</div>\n          </div>\n        </div>\n        <div class="col-md-6">\n          <div class="form-group">\n            <label class="control-label">Отправитель</label>\n            <input class="form-control" name="sender" value="{item.sender}">\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group {has-error: error.text}">\n            <label class="control-label">Текст</label>\n            <textarea class="form-control" name="text" value="{item.text}" rows="5" style="min-width: 100%; max-width: 100%;"></textarea>\n            <div class="help-block">{error.text}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <div class="checkbox-inline">\n              <label>\n                <input name="isActive" type="checkbox" __checked="{item.isActive == 1}">Активен\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.item = {};
self.loader = false;
self.error = false;
self.mixin('permissions');
self.mixin('validation');
self.mixin('change');

self.rules = {
    name: 'empty',
    code: 'empty',
    text: 'empty',
    phone: {
        required: true,
        rules: [{
            type: 'phone'
        }]
    }
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

self.submit = function (e) {
    var params = self.item;
    self.error = self.validation.validate(params, self.rules);

    if (!self.error) {
        API.request({
            object: 'SmsTemplate',
            method: 'Save',
            data: params,
            success: function success(response) {
                self.item = response;
                popups.create({ title: 'Успех!', text: 'SMS шаблон сохранен!', style: 'popup-success' });
                observable.trigger('sms-reload');
            }
        });
    }
};

self.reload = function () {
    observable.trigger('sms-edit', self.item.id);
};

observable.on('sms-edit', function (id) {
    self.item = {};
    self.loader = true;
    self.error = false;
    var params = { id: id };
    self.update();

    API.request({
        object: 'SmsTemplate',
        method: 'Info',
        data: params,
        success: function success(response) {
            self.item = response;
        },
        error: function error(response) {
            self.item = {};
        },
        complete: function complete() {
            self.loader = false;
            self.update();
        }
    });
});

observable.on('sms-new', function () {
    self.item = {};
    self.loader = false;
    self.error = false;
});
});


// WEBPACK FOOTER //
// ./pages/settings/sms/sms-template-edit.tag